import axios from "axios"
import { RouterProvider } from "react-router-dom"

import nprogress from 'nprogress'

import { router } from '@/routes'
import { PageProvider } from "@/contexts/page-context"
import Toast from "@/components/toast"

export default function App() {
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        nprogress.start()
        return config
    }, function (error) {
        // Do something with request error
        nprogress.done()
        console.error(error)
        return Promise.reject(error)
    })

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
        // Do something with response data
        nprogress.done()
        return response
    }, function (error) {
        // Do something with response error
        nprogress.done()
        console.error(error)
        return Promise.reject(error)
    })

    return (
        <PageProvider>
            <div>
                <RouterProvider router={router} />
            </div>
            <Toast />
        </PageProvider>
    )
}